$(function () {
    //region selector

    $('.js-fr-selector-button').click(function () {

        let parent = $(this).closest('.js-fr-selector')

        if ($(this).hasClass('open')) {

            $(this).removeClass('open')
            $('.js-fr-selector-list', parent).slideUp(150)

        } else {

            $(this).addClass('open')
            $('.js-fr-selector-list', parent).slideDown(150)

        }

    })

    $(document).click(function (event) {

        let $target = $(event.target);

        if (!$target.closest('.js-fr-selector').length && $('.js-fr-selector-list').is(":visible")) {

            $('.js-fr-selector-list').slideUp(150)
            $('.js-fr-selector-button').removeClass('open')

        }

    })

    //endregion

    //region faq

    $('.js-faq-button').click(function () {

        let parent = $(this).closest('.js-faq-item')

        $(this).toggleClass('open')
        $('.js-faq-content', parent).slideToggle(150)

    })

    //endregion

    //region gallery

    let activeGallery
    let activeGalleryItem

    $('.js-galley-item').click(function () {

        activeGallery = $(this).closest('.js-galley')
        activeGalleryItem = $(this)

        openModalGallery()

    })

    $(document).on('click', '.gallery-modal__background', function () {

        closeModalGallery()

    })

    $(document).on('click', '.gallery-modal__close', function () {

        closeModalGallery()

    })

    $(document).on('click', '.gallery-modal__prev', function () {

        goPrevGallery()

    })

    $(document).on('click', '.gallery-modal__next', function () {

        goNextGallery()

    })

    $(document).on('click', '.gallery-modal__image', function () {

        goNextGallery()

    })

    // $(document).bind('keypress', function(event) {
    //
    //     console.log(event)
    //
    // })

    $(document).keydown(function(event) {

        if ((event.which === 27 || event.keyCode === 27) && $('.gallery-modal').length) {

            closeModalGallery()

        }

        if ((event.which === 39 || event.keyCode === 39) && $('.gallery-modal').length) {

            goNextGallery()

        }

        if ((event.which === 37 || event.keyCode === 37) && $('.gallery-modal').length) {

            goPrevGallery()

        }

    });

    function openModalGallery() {

        let modal = '' +
            '<div class="gallery-modal">' +
            '<div class="gallery-modal__background"></div>' +
            '<div class="gallery-modal__content">' +
            '<div class="gallery-modal__button gallery-modal__close">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">\n' +
            '<path fill-rule="evenodd" clip-rule="evenodd" d="M10.5858 12L6.29291 7.70711L7.70712 6.29289L12 10.5858L16.2929 6.29289L17.7071 7.70711L13.4142 12L17.7071 16.2929L16.2929 17.7071L12 13.4142L7.70712 17.7071L6.29291 16.2929L10.5858 12Z" fill=""/>\n' +
            '</svg>' +
            '</div>' +
            '<div class="gallery-modal__button gallery-modal__prev">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">\n' +
            '<path d="M15 5L8 12L15 19" stroke="" stroke-width="2"/>\n' +
            '</svg>' +
            '</div>' +
            '<div class="gallery-modal__image">' +
            '<img src="' + activeGalleryItem.data('image-url') + '" >' +
            '</div>' +
            '<div class="gallery-modal__button gallery-modal__next">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">\n' +
            '<path d="M9 19L16 12L9 5" stroke="" stroke-width="2"/>\n' +
            '</svg>' +
            '</div>' +
            '</div>'
        '</div>'

        $('html').append(modal).css({overflow: 'hidden'})

    }

    function closeModalGallery() {

        $('.gallery-modal').remove()

        $('html').css({overflow: 'visible'})

    }

    function goNextGallery() {


        if (!!activeGalleryItem.next().length) {

            activeGalleryItem = activeGalleryItem.next()

        } else {

            activeGalleryItem = $('.js-galley-item').first()

        }

        $('img', $('.gallery-modal__image')).attr('src', activeGalleryItem.data('image-url'))

    }

    function goPrevGallery() {

        if (!!activeGalleryItem.prev().length) {

            activeGalleryItem = activeGalleryItem.prev()

        } else {

            activeGalleryItem = $('.js-galley-item').last()

        }

        $('img', $('.gallery-modal__image')).attr('src', activeGalleryItem.data('image-url'))

    }

    //endregion

    //region nav fixed

    $('.js-nav-fixed-item').mouseenter(function (e) {

        if (e.target !== $('.fr-nav-fixed__item-label', $(this))[0])
            $('.js-nav-fixed-label', $(this)).fadeIn(150)

    })

    $('.js-nav-fixed-item').mouseleave(function () {

        $('.js-nav-fixed-label', $(this)).fadeOut(150)

    })

    $('.js-anchor').each(function () {
        selectActiveLink('.js-anchor', '.js-anchor-link')
    })
    $('.js-anchor-content').each(function () {
        selectActiveLink('.js-anchor-content', '.js-anchor-content-link')
    })

    $(window).scroll(function () {
        selectActiveLink('.js-anchor', '.js-anchor-link')
        selectActiveLink('.js-anchor-content', '.js-anchor-content-link')

        if ($(document).scrollTop() >= $('.js-anchor').eq(1).offset().top) {

            $('.js-nav-fixed').addClass('show')
            $('.js-batman').addClass('show')

        } else {

            $('.js-nav-fixed').removeClass('show')
            $('.js-batman').removeClass('show')

        }

        if ($(document).scrollTop() >= $('.beboss-footer').offset().top - $(window).height()) {

            $('.js-batman').removeClass('show')

        }

    })

    if (!$('.fr-head__nav-item', $('.js-nav-fixed-list')).length) {

        $('.js-nav-fixed-list').append($('.js-nav-fixed-template').clone())

    }

    $('.js-nav-fixed-open-list').click(function () {

        $('.js-nav-fixed-list').slideToggle(150)

        mobileMenuShow()

    })

    $('.fr-head__nav-item', $('.js-nav-fixed-list')).click(function () {

        $('.js-nav-fixed-list').slideUp(150)

        mobileMenuShow()

    })

    function mobileMenuShow() {

        $('.js-nav-fixed').toggleClass('open')

        if ($('.js-nav-fixed').hasClass('open')) {

            $('.js-nav-fixed-item.active').fadeOut(150, function () {

                $('.js-nav-fixed-name').fadeIn(150)

            })

        } else {

            $('.js-nav-fixed-name').fadeOut(150, function () {

                $('.js-nav-fixed-item.active').fadeIn(150)

            })

        }

    }

    function selectActiveLink(anchor, anchorLink) {
        $(anchor).each(function () {
            let currentId = ''
            if ($(this).offset().top + $(this).next().innerHeight() >= $(window).scrollTop()
                && $(this).offset().top - 64 <= $(window).scrollTop()) {
                if (currentId = '' || currentId !== $(this).attr('id')) {
                    currentId = $(this).attr('id')
                    $(anchorLink).removeClass('active')
                    $(anchorLink + '[href="#' + currentId + '"]').addClass('active')
                }
            }
        })
    }

    //endregion

    //region modal video


    let _bCaptcha = window._bCaptcha,
        global = this,
        contactType = false;

    $('.js-modal-open').click(function (e) {

        e.preventDefault()

        let cType = $(this).data('modal-contact-type')

        if (cType && cType !== 'undefined') {
            contactType = cType;
        }

        let
            modalNext,
            modalCurrent = $(this).attr('data-modal');

        if (!!$(this).attr('data-modal-next')) {

            modalNext = $(this).attr('data-modal-next')
        }

        global.modalCurrentId = modalCurrent;
        global.modalNextId = modalNext;

        openModalMiddleware(modalCurrent, modalNext)

        if (!!$(this).attr('data-id-video')) {

            appendVideo($(this).attr('data-id-video'))

        }

    })

    $('.js-modal-close').click(function () {

        closeModal($(this).data('modal'))

    })

    function openModalMiddleware(id, nextId) {
        if (nextId) {
            if (contactType) {
                $('.js-modal-error-msg').text('');

                _bCaptcha.resetAll()
            }

            openModal(id, nextId)
        } else {
            sendRequestToGetContact();
        }

        if (!contactType) {
            openModal(id, nextId)
        }
    }

    function openModal(id, nextId) {

        $('.js-modal').fadeOut(150, function () {

            $('iframe', $('.js-modal')).remove()

        })

        $('html').css({overflow: 'hidden'})

        $('.js-modal[data-modal=' + id + ']')
            .fadeIn(150)
            .css({display: 'flex'})

        if ($('.js-modal-next', $('.js-modal[data-modal=' + id + ']')).length && !!nextId) {

            $('.js-modal-next', $('.js-modal[data-modal=' + id + ']')).attr('data-modal', nextId)

        }

        if ($('.js-site-link', $('.js-modal[data-modal=' + id + ']')).length) {

            let href = $('.js-site-link', $('.js-modal[data-modal=' + id + ']')).attr('href')
            window.open(href, '_blank').focus();

        }

    }

    function closeModal(id) {

        $('html').css({overflow: 'visible'})

        $('.js-modal').fadeOut(150, function () {

            $('iframe', $('.js-modal')).remove()

        })

    }

    function appendVideo(id) {

        let iframe = '<iframe width="560" height="315" src="https://www.youtube.com/embed/' + id + '?si=Ud73_E8SsOa33NJY&autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>'

        $('.js-video').append(iframe)

    }

    //endregion

    $('.js-become-vip').click(function (e) {
        if($(this).data('auto-auth') === true){
            e.preventDefault();

            closeModal($(this).data('modal'))
        }
    })


    function sendRequestToGetContact() {
        if (contactType) {
            let
                idCaptcha = $('.js-BebossCaptchaInit').data('bcaptcha-id'),
                frId = $('#franchise_id').val();

            if (idCaptcha && frId > 0) {
                let captcha = _bCaptcha._getCaptchaObject(idCaptcha);

                if (captcha) {
                    let needSendRequest = captcha.isCheckboxHidden();

                    if (captcha.needValidateOnClient()) {
                        if (needSendRequest) {
                            _bCaptcha._getCheckCodeRequest(idCaptcha)
                        }

                        setTimeout(function () {
                            if (_bCaptcha.getRequestResult()) {
                                $.ajax({
                                    url: "/franchise/xajax/get-contact",
                                    type: 'POST',
                                    data: {
                                        "objectType": 'fr',
                                        "objectId": frId,
                                        "contactType": contactType,
                                        "_csrf": yii.getCsrfToken(),
                                    },
                                    dataType: 'json',
                                    loadIcon: true,
                                    loadBack: true,
                                    success: function (res) {
                                        $('.js-modal-error-msg').text('');

                                        if (res.result) {
                                            if (contactType === 'phone') {
                                                $('#fr_modal_phone').text(res.data.contact)

                                                openModal(global.modalCurrentId, global.modalNextId)
                                            }

                                            if (contactType === 'site') {
                                                window.location.replace(res.data.contact);
                                            }
                                        } else {
                                            $('.js-modal-error-msg').text(res.message)

                                            _bCaptcha.setRequestResult(false)
                                        }

                                    }, error: function (res) {
                                        showError()

                                        _bCaptcha.setRequestResult(false)
                                    }
                                });
                            } else {
                                showError()
                            }
                        }, 1300);
                    } else {
                        showError()
                    }
                } else {
                    showError()
                }
            }
        }

        function showError() {
            $(".js-modal-error-msg").text($(".js-modal-error-msg").data("error-message"))
        }
    }

    $('.input-with-movement').each( function () {

        if ($('input', $(this)).length && $('input', $(this)).val().trim() !== '') {

            $(this).addClass('active')

        }
        if ($('textarea', $(this)).length && $('textarea', $(this)).val().trim() !== '') {

            $(this).addClass('active')

        }

    })

    $('.input-with-movement').click( function () {

        $('input', $(this)).trigger('focus')
        $('textarea', $(this)).trigger('focus')
        $(this).addClass('focused')
        $(this).addClass('active')

    })

    $('.input-with-movement').on('click', 'label', function () {

        let parent = $(this).closest('.input-with-movement')

        if (!parent.hasClass('focused')) {

            if ($('input', parent).length) {

                $('input', parent).trigger('focus')

            }

            if ($('textarea', parent).length) {

                $('textarea', parent).trigger('focus')

            }

            parent.addClass('focused')
            parent.addClass('active')

        }

    })

    inputBlur('input')
    inputBlur('textarea')
    focusInput('input')
    focusInput('textarea')

    function inputBlur(type) {

        $(type, $('.input-with-movement')).blur( function () {

            let parent = $(this).closest('.input-with-movement')

            if ($(this).val().trim() === '') {

                parent.removeClass('focused')
                parent.removeClass('active')

            } else {

                parent.removeClass('focused')

            }

        })



    }

    function focusInput(type) {

        $(type, $('.input-with-movement')).focus( function () {

            let parent = $(this).closest('.input-with-movement')

            parent.addClass('focused')
            parent.addClass('active')

        })

    }
})
//# sourceMappingURL=index.js.map
